import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {SharedService} from '../../shared/shared.service';
import {NgForm} from '@angular/forms';
import {AuthenticationService, TwoFAService, UserService} from '../../_services';
import {Constants} from '../../shared/Helpers/constants';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import * as moment from 'moment';
import {CookieService} from 'ngx-cookie';
import {HttpResponse} from '@angular/common/http';
import { UserContext } from 'src/app/_context/user.context';
import { IUser2FAConfiguration } from 'src/app/shared/interfaces';
import Swal from 'sweetalert2';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';
import {AuthXService, WorkflowStep} from '@authx/authx-workflow-lib';

@Component({
  selector: 'verify-code',
  templateUrl: './verify-code.component.html'
})
export class VerifyCodeComponent implements OnInit, OnChanges {
  @Input() showLastVerificationCodeToLogin: boolean = false;
  @Input() isChangingDevice: boolean = false;
  @Input() setup: boolean = false;
  @Input() smsEnabled: boolean;
  @Input() userConfig: IUser2FAConfiguration;
  @Input() setupMethodChoosen: any = null;
  @Output() methodSwitched = new EventEmitter<any>();
  @Output() changePhoneNo = new EventEmitter<any>();
  @Output() changeDevice = new EventEmitter<any>();
  @Output() goToSetup = new EventEmitter<any>();
  @Output() deviceConfirmSuccess = new EventEmitter<boolean>();
  @Output() logoHidden = new EventEmitter<boolean>();

  public twoFAMethod: any = 'app';
  public numberLastDigits: any = null;
  public methodsSetup;
  public f: NgForm;
  public sendNewCode: boolean = true;
  public model: any;
  public resendCount: number = 1;
  public pendingAppState: boolean;
  public peopleData: any;
  public passwordDaysExpire: number;
  public hasExpired: boolean;
  public controlPasswordExpired: boolean = false;
  private firstLoginDataPeople: Date;
  public checkFirstLogin: boolean = false;
  public passwordExpiry: boolean = false;
  public LoggedInUserListCheck: boolean;
  private currentloginDate: any;

  constructor(
    public sharedService: SharedService,
    public authenticationService: AuthenticationService,
    private twoFAService: TwoFAService,
    private userService: UserService,
    private cookieService: CookieService,
    private route: Router,
    private authXService: AuthXService
  ) {

  }

  ngOnInit() {
    this.initModel();
    this.getValues(this.userConfig)
  }

  initModel() {
    this.model = {
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: ''
    }
  }

  ngOnChanges(changes: any) {
    if (changes.userConfig) {
      this.getValues(this.userConfig);
    }
  }

  public getValues(userConfig: IUser2FAConfiguration) {
    if (userConfig) {
      this.twoFAMethod = userConfig.typeEnabled
      this.getMethodsSetup(userConfig);
      if (this.twoFAMethod == 'SMS' && userConfig.smsAuthenticator) {
        this.numberLastDigits = this.userConfig.smsAuthenticator.phoneNumber.substr(this.userConfig.smsAuthenticator.phoneNumber.length - 3, 3)
      }
      if (this.userConfig.appAuthenticator) {
        this.pendingAppState = this.userConfig.appAuthenticator.authorisationStatus === 'PENDING' ? true : false
      }
    } else {
      this.twoFAMethod = this.setupMethodChoosen;
      this.methodsSetup = ''
    }
  }

  public getMethodsSetup(userConfig) {
    if (userConfig.appAuthenticator && this.userConfig.appAuthenticator.authorisationStatus != 'PENDING' && userConfig.smsAuthenticator) {
      this.methodsSetup = 'BOTH'
    } else {
      // app is pending
      if (userConfig.smsAuthenticator && userConfig.appAuthenticator) {
        this.methodsSetup = 'SMS'
      } else if (userConfig.appAuthenticator) {
        if (this.userConfig.appAuthenticator.authorisationStatus == 'PENDING') {
          this.methodsSetup = ''
        } else {
          this.methodsSetup = 'APP'
        }

      } else if (userConfig.smsAuthenticator) {
        this.methodsSetup = 'SMS'
      }
    }
  }

  // keypress does not detect backspace or ctrl key, so use keyup/keydown
  public onKeyUp(event) {
    // when digits
    if (event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 96 && event.keyCode <= 105) {
      // if there is an existing value, replace it, bacause maxlength 1 does not allow the digit to be added
      event.srcElement.value = parseInt(event.key, 10);
      this.model[event.srcElement.name] = event.key;
      this.focusNextElement(event);
      return true;
    }
    // backspace
    else if (event.keyCode == 8) {
      this.focusPrevElement(event);
      return true;
    }
    // left arrow
    else if (event.keyCode == 37) {
      this.focusPrevElement(event);
      return true;
    }
    // right arrow
    else if (event.keyCode == 39) {
      this.focusNextElement(event);
      return true;
    }
    // delete
    else if (event.keyCode == 46) {
      this.model[event.srcElement.name] = '';
      this.focusNextElement(event);
      return true;
    } else {
      return false
    }
  }

  // it might need to be changed on html changes
  public focusNextElement(event) {
    const parentSibling = event.srcElement.parentElement.nextElementSibling;
    if (parentSibling) {
      const element = parentSibling.children[0];
      if (element) {
        element.focus();
        // put cursor at the end
        const elementVal = element.value;
        element.value = ''
        element.value = elementVal
      }
    }
  }

  public focusPrevElement(event) {
    const parentSibling = event.srcElement.parentElement.previousElementSibling;
    if (parentSibling) {
      const element = parentSibling.children[0];
      if (element) {
        element.focus();
        // put cursor at the end
        const elementVal = element.value;
        element.value = ''
        element.value = elementVal
      }
    } else {
      // put cursor at the end
      event.srcElement.focus();
      const elementVal = event.srcElement.value;
      event.srcElement.value = ''
      event.srcElement.value = elementVal
    }
  }

  public putCursorAtEnd(event) {
    const val = event.srcElement.value
    event.srcElement.value = ''
    event.srcElement.value = val
  }

  public verifyCode() {
    this.resendCount++;
    const codeToSend: string = this.model.digit1 + this.model.digit2 + this.model.digit3 + this.model.digit4 +
      this.model.digit5 + this.model.digit6
    if (codeToSend.length == 6) {
      // TWO options: 1-route to login, 2- redirect to 8080 from here

      const kot = this.isChangingDevice;
      if ((this.twoFAMethod == 'APP' && this.pendingAppState) || this.isChangingDevice == true) {
        if (this.showLastVerificationCodeToLogin) {
          this.verifyLoginCode(codeToSend);
        } else {
          localStorage.setItem('currentOrg', this.sharedService.currentOrganisationId.value);
          localStorage.setItem('loggedUser', this.sharedService.loggedUserId.value);
          localStorage.setItem('code', codeToSend);
          this.route.navigateByUrl('/app-authentication?change-device');
        }
      } else {
        this.verifyLoginCode(codeToSend);
      }
    }
  }

  public verifyLoginCode(codeToSend) {
    this.currentloginDate = moment.utc().subtract(4, 'seconds').toISOString();
    this.authenticationService.loginWithAuthenticatingOrganisation(this.sharedService.userAttemptedLoginUsername.value, this.sharedService.userAttemptedLoginPassword.value, this.sharedService.currentOrganisationId.value, codeToSend).subscribe({
      next: (res) => {
        if (res.body) {
          this.sharedService.changeUserAttemptedLoginPassword(null)
          const user = res.body;
          localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify(user));
          let idamUrl: string = environment.identityCookieUrl;
          idamUrl = idamUrl.substr(idamUrl.indexOf('//') + 2);
          idamUrl = idamUrl.substr(0, idamUrl.indexOf(':'));
          if (idamUrl.indexOf('.') > -1) {
            idamUrl = idamUrl.substr(idamUrl.indexOf('.'));
          }
          this.cookieService.put('ABLEIDENTITY', user.token, {path: '/', expires: moment(new Date()).add(30, 'm').toDate(), domain: idamUrl});
          this.getPeopleData();
        }
      },
      error: (error) => {
        if (error.status === 401) {
          let msg = error.error.detailedMessage;
          if (msg.indexOf('for user') > 0) {
            msg = msg.substr(0, msg.indexOf('for user'))
          }
          Alert.basicNotification(AlertTypeEnum.Error, "", msg);
        }
        if (error.status === 401 && error.error.errorCode === 1100) {
            this.authXService.execute({
              organisationId: this.sharedService.currentOrganisationId.value,
              workflowStep: error.error.workflowStep as WorkflowStep,
              onSuccess: token => {
                localStorage.setItem(Constants.localStorage_currentUser, JSON.stringify({token: token}));
                this.getPeopleData();
              }
            });
        }
      }
    })
  }

  getOrganisationIdByHomeUser() {
    this.userService.getHomeUser(this.peopleData.id).subscribe((userData) => {
      const filterUser = userData.body.filter(item => item.isHomeUser == true);
      this.sharedService.changeCurrentOrganisationId(filterUser[0].organisation.id);
      this.sharedService.changeLoggedUserId(filterUser[0].id);
      this.checkIfSamlRequestExistsInLocalStorage();
    });
  }

  private async getPeopleData() {
    const currentUser = new UserContext();
    if (currentUser.isAuthenticated) {
      this.userService.getPeopleById(currentUser.personID).subscribe({
        next: (data) => {
          this.peopleData = data.body;
          this.firstLoginDataPeople = this.peopleData.firstLoginDate;
          this.checkPasswordExpiry();
        },
        error: (error) => {
          if (error.status === 0) {
            this.checkFirstLogin = false;
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;

          } else if (error.status === 401) {
            if (error.error.errorCode === 1012) {
              this.checkFirstLogin = true;
            } else if (error.error.errorCode === 1010) {
              this.checkFirstLogin = false;
            }
            this.sharedService.storeFirstLoginForExpiryPassword(this.checkFirstLogin);
            this.controlPasswordExpired = true;
            this.hasExpired = true;
            this.peopleData = {};
            this.passwordExpiry = true;
          }
        }
      });
    }
  }

  public onSkip() {
    this.passwordExpiry = false;
    this.checkIfSamlRequestExistsInLocalStorage();
  }

  public onReset() {
    this.passwordExpiry = false;
    this.route.navigate(['reset-password']);
  }

  // check password exiry
  private checkPasswordExpiry() {
    // check if password expired date is less than 7 days.
    // Get the current date
    const todayDate = new Date();
    // Set start/end dates to a specified date
    const expiryDate = new Date(this.peopleData.passwordExpiryDate);

    // Compare the two dates
    const duration = Math.floor((Date.UTC(expiryDate.getFullYear(), expiryDate.getMonth(), expiryDate.getDate())
      - Date.UTC(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate())) / (1000 * 60 * 60 * 24));

    this.passwordDaysExpire = duration;

    if (this.passwordDaysExpire <= 7) {
      this.userService.checkPeopleLastAccess(this.peopleData.id).subscribe((data) => {
        const checkLastAccess = data.body;

        if (checkLastAccess.shouldDisplayMessage) {
          if (duration <= 7 && duration > 2) {
            this.controlPasswordExpired = true;
            this.passwordExpiry = true;
            // show popup to reset password or to skip it
          } else if (duration <= 2) {
            if (duration <= 0) {
              this.controlPasswordExpired = true;
              this.hasExpired = true;
              this.passwordExpiry = true;
            } else {
              this.controlPasswordExpired = true;
              this.passwordExpiry = true;
            }
          } else {
            this.checkIfSamlRequestExistsInLocalStorage();
          }
        } else {
          if (duration <= 2) {
            if (duration <= 0) {
              this.controlPasswordExpired = true;
              this.hasExpired = true;
              this.passwordExpiry = true;
            } else {
              this.controlPasswordExpired = true;
              this.passwordExpiry = true;
            }
          } else {
            this.checkIfSamlRequestExistsInLocalStorage();
          }
        }
        if (!this.passwordExpiry &&
          (!this.controlPasswordExpired || !this.LoggedInUserListCheck ||
            (!this.controlPasswordExpired && !this.LoggedInUserListCheck)
          )
        ) {

        } else {
        }
      });
    } else {
      if (this.compareFirstLoginWithCurrentLoginDate(this.firstLoginDataPeople, this.currentloginDate)) {
        this.getOrganisationIdByHomeUser();

      } else {
        this.checkIfSamlRequestExistsInLocalStorage();
      }
    }
  }

  private compareFirstLoginWithCurrentLoginDate(firstLoginDate, currentLoginDate: string): boolean {
    return (firstLoginDate > currentLoginDate) ? true : false;
  }

  private checkIfSamlRequestExistsInLocalStorage() {
    if (localStorage.getItem('samlRequest')) {
      const data = JSON.parse(localStorage.getItem('samlRequest')!);
      localStorage.removeItem('samlRequest');
      let queryParam: string;
      queryParam = '?tenant=tenant1';
      if (data.method == 'POST') {
        const bodyPost = 'SAMLRequest=' + encodeURIComponent(data.samlRequest) + '&RelayState=' + encodeURIComponent(data.relayState);
        if (data.orgIds != null && data.orgIds != '') {
          this.authenticationService.samlSsoRequest(data.requestUrl, data.orgIds, 'POST', queryParam, bodyPost).subscribe({
            next: () => {
              this.openWindow(data)
              this.authenticationService.redirect(this.sharedService.returnUrl.value);
            },
            error: () => {
              this.authenticationService.redirect(this.sharedService.returnUrl.value);
            }
          })
        } else {
          this.authenticationService.samlSsoRequestWithoutOrg('POST', queryParam, bodyPost).subscribe({
            next: () => {
              this.openWindow(data);
            },
            error: () => {
              this.authenticationService.redirect(this.sharedService.returnUrl.value);
            }
          })
        }
      } else {
        queryParam += '&SAMLRequest=' + encodeURIComponent(data.samlRequest) + '&RelayState=' + encodeURIComponent(data.relayState);
        if (data.orgIds != null && data.orgIds != '') {
          this.authenticationService.samlSsoRequest(data.requestUrl, data.orgIds, 'GET', queryParam).subscribe(data => {
            this.openWindow(data)
          })
        } else {
          this.authenticationService.samlSsoRequestWithoutOrg('POST', queryParam).subscribe({
            next: () => {
              this.openWindow(data);
            },
            error: () => {
              this.authenticationService.redirect(this.sharedService.returnUrl.value);
            }
          })
        }
      }
    } else {
      this.authenticationService.redirect(this.sharedService.returnUrl.value);
    }
  }

  private openWindow(data: HttpResponse<string>) {
    const markup: any = data.body;
    const wnd = window.open('about:blank', '');

    if (!wnd || wnd.closed || typeof wnd == 'undefined' || typeof wnd.closed == 'undefined') {
      const msg: any = ' <p> Your browser is blocking pop ups, please allow them and click here to be redirected</p>';
      Swal.fire({
        title: 'Allow popup',
        html: msg,
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonText: 'Click here',
        customClass: 'sweetalert-lg',
        width: '500px'
      }).then((result) => {
        const wnd: any = window.open('about:blank', '');
        wnd.document.write(markup);
        wnd.document.close();
        const win: any = window.open('about:blank', '_self');
        win.close();
        window.close();
      });
    } else {
      wnd.document.write(markup);
      wnd.document.close();
      window.close();
    }
  }

  public changeTwoFaMethod(method: any) {
    this.twoFAMethod = method;
  }

  public switch2FAMethod() {
    if (this.twoFAMethod == 'APP') {
      this.resendCode('SMS');
    } else if (this.twoFAMethod == 'SMS') {
      this.resendCode('APP');
    }
  }

  public resendCode(twoFAMethod: any) {
    this.twoFAService.resend2FACode(this.sharedService.currentOrganisationId.value, this.sharedService.loggedUserId.value, twoFAMethod).subscribe({
      next: () => {
        // user config has changed, so we need to emit, and get the updated the updated object
        // hope there is no other case in which we should as well emit, even though the method has not changed
        if (this.twoFAMethod != twoFAMethod) {
          this.twoFAMethod = twoFAMethod;
          this.methodSwitched.emit();
        }
        this.initModel();
      },
      error: (error) => {
        if (error.error.errorCode === 1018) {
          this.pendingAppState = true;
        } else if (error.error.errorCode === 1006) {
          Alert.basicNotification(AlertTypeEnum.Error, "", error.error.detailedMessage);
        }
        if (this.twoFAMethod != twoFAMethod) {
          this.twoFAMethod = twoFAMethod;
          if (twoFAMethod == 'SMS' && this.userConfig.smsAuthenticator && this.userConfig.smsAuthenticator.phoneNumber) {
            this.numberLastDigits = this.userConfig.smsAuthenticator.phoneNumber.substr(this.userConfig.smsAuthenticator.phoneNumber.length - 3, 3);
          }
        }
      }
    })
  }

  changeMobileNo() {
    this.changePhoneNo.emit();
  }

  onGoToSetup() {
    this.goToSetup.emit();
  }

  changeDeviceBinding() {
    this.changeDevice.emit();
  }

}
